/**
 * Helper function to validate decimal input (allows up to 2 decimal places)
 */
export const validateDecimalInput = (value: string): boolean => {
  if (value === '') return true;
  
  // Remove % symbol and commas for validation
  const cleanValue = value.replace('%', '').replace(/,/g, '');
  
  // Allow decimal numbers with up to 2 decimal places
  const decimalRegex = /^\d*\.?\d{0,2}$/;
  return decimalRegex.test(cleanValue);
};

/**
 * Helper function to validate KCPH input (only allows numbers, commas and decimals, no special characters)
 */
export const validateKCPHInput = (value: string): boolean => {
  if (value === '') return true;
  
  // Strip commas before validating
  const cleanValue = value.replace(/,/g, '');
  // Only allow numbers and one decimal point with up to 2 decimal places
  // No special characters, symbols, or letters allowed
  const kcphRegex = /^[0-9]*\.?[0-9]{0,2}$/;
  return kcphRegex.test(cleanValue);
};

/**
 * Helper function to check if restore value should be green
 */
export const isRestoreValueCorrect = (value: string, displayAsPercentage: boolean = true): boolean => {
  if (displayAsPercentage) {
    return value === '100%' || value === '100.00%';
  } else {
    // When displayAsPercentage is false, we don't validate - always return false to use blue styling
    return false;
  }
};